import { SafeLogger } from "./safe-logger";

export class ValidationUtil {

    static validate(unsafe: any) {
        if ((typeof unsafe) !== 'string')
            return unsafe;


        let pattern = new RegExp('^[a-zA-Z0-9-/]*$');

        if (pattern.test(unsafe)){
            return unsafe;
        } else {
            SafeLogger.log(unsafe + " not valid");
            return "invalid";
        }

    }

}
